import SelectPlanCheckoutView from 'components/Checkout';
import { SelectPlanGlobalStyles } from 'components/Checkout/styles';
import SelectPlanCheckoutContextProvider from 'contexts/SelectPlanCheckoutContextProvider';

const BuyNowWithDiscountAndCheckout = () => (
  <SelectPlanCheckoutContextProvider isFromTrial>
    <SelectPlanGlobalStyles />
    <SelectPlanCheckoutView isTrial />
  </SelectPlanCheckoutContextProvider>
);

export default BuyNowWithDiscountAndCheckout;
